export default "/images/405a20bdf91aa6df118212ac7e5c0676.avif";